import style from './style.css';

const Loading = () => (
	<div class={style.profile}>
    <center><img src='./assets/puff.svg' /></center>
	</div>
);

export default Loading;
